import { render, staticRenderFns } from "./EstatusView.vue?vue&type=template&id=8a9a4b9e&"
import script from "./EstatusView.vue?vue&type=script&lang=js&"
export * from "./EstatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports